import $http from '../../axios-instance';
import Swal from 'sweetalert2';


export async function listarListasChequeo({state, commit}, requestParameters = {params: state.filtro}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_general/lista-chequeo', requestParameters)
        .then((response) => {
            commit('setListasChequeo', response.data.data);
            commit('setDataToChartGeneralFindings', response.data.complianceStatus);
            commit('setDataToChartPercentageOfComplianceByItem', response.data.percentageOfComplianceByItem);
            commit('dashboard/load', false, {root: true});
            return response.data.data;
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearListaChequeo({commit, state}) {

    commit('dashboard/load', true, {root: true});

    return await new Promise(async (resolve, reject) => {

        commit('cargaHallazgos', state.listaTipoSeguimientos);

        await $http.post('adm_general/lista-chequeo/crear', state.selectedListaChequeo)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: true,
                    timer: 5000
                });
                commit('setListaChequeo', response.data.lista_chequeo);
                resolve();
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
                reject();
            });
    });
}

export async function mostrarListaChequeo({commit, state, dispatch}, {id_lista, id_empresa}) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`adm_general/lista-chequeo/mostrar/${id_lista}/${id_empresa}`)
        .then(async (response) => {
            commit('setListaChequeo', response.data.data);
            commit('establecerEmpresas', [response.data.data.empresa]);
            if (response.data.data.id_ubicacion) {
                await dispatch('obtenerUbicaciones', response.data.data.id_empresa);
            }
            commit('dashboard/load', false, {root: true});
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit('accionError', error.message);
        });
}

export async function desactivarListaChequeo({commit, state, dispatch}, {id_lista, id_empresa}) {

    await Swal.fire({
        title: 'Cambiar estado',
        text: '¿Está seguro de cambiar el estado de la lista de chequeo?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, cambiar'
    }).then(async (result) => {
        if (result.value) {
            await $http.delete(`adm_general/lista-chequeo/inactivar/${id_lista}/${id_empresa}`)
                .then(async (response) => {
                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 5000
                    });
                    await dispatch('listarListasChequeo');
                }).catch((error) => {
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: error.message + '<br> ' + error.errors,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}

/**
 * Obtener empresas
 */
export async function obtenerEmpresas({dispatch, commit, state}, nombre) {
    dispatch('obtenerEmpresasPeticion', nombre)
        .then(empresas => commit('establecerEmpresas', empresas));
}

/**
 * Obtener empresas filtro
 */
export async function obtenerEmpresasFiltro({commit, dispatch}, nombre) {
    dispatch('obtenerEmpresasPeticion', nombre)
        .then(empresas => commit('establecerEmpresasFiltro', empresas));
}

/**
 * Obtener empresas desde el back
 */
export async function obtenerEmpresasPeticion({commit, state}, nombre) {

    return await new Promise(async (resolve, reject) => {
        if (!state.cargando_datos_select && nombre && nombre.length > 1) {
            commit('establecerCargandoDatosSelect', true);

            let parametros = {
                params: {
                    nombre: nombre
                }
            };

            await $http.get('/empresas/lista', parametros)
                .then((response) => {
                    resolve(response.data.data);
                    commit('establecerCargandoDatosSelect', false);
                })
                .catch(() => {
                    console.warn('No se encontraron empresas con el nombre especificado');
                    reject([]);
                    commit('establecerCargandoDatosSelect', false);
                });
        }
    });
}

export async function actualizarListaChequeo({commit, state, dispatch}) {

    commit('Actualizar', 'Actualizar');
    commit('cargaHallazgos', state.listaTipoSeguimientos);
    commit('dashboard/load', true, { root: true });

    $http.put(`adm_general/lista-chequeo/editar/${state.selectedListaChequeo.id}`, state.selectedListaChequeo)
        .then(async (response) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });

            await dispatch('mostrarListaChequeo', {
                id_lista: state.selectedListaChequeo.id,
                id_empresa: state.selectedListaChequeo.id_empresa
            });
            await dispatch('obtenerUbicacionesRequest', state.selectedListaChequeo.id_empresa);
            await dispatch('listarTipoSeg');

        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        }).finally(() => commit('dashboard/load', false, { root: true }))
}

export async function listarTipoListaChequeo({dispatch, state, rootState, commit}, id_empresa) {

    commit('dashboard/load', true, {root: true});

    let parametros = {
        params: {
            id_empresa: id_empresa
        }
    };

    await $http.get('adm_general/tipo-lista-chequeo', parametros)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setListarTipoListaChequeo', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

// filtro de paginacion
export function setPagePagination({commit, dispatch}, page) {
    commit('setPage', parseInt(page));
    dispatch('listarListasChequeo');
}


export async function listarTipoSeg({state, commit}) {

    const parametros = {
        params: {
            id_tipo_lista_chequeo: state.selectedListaChequeo.id_tipo_lista_chequeo
        }
    };

    commit('dashboard/load', true, {root: true});

    await $http.get('adm_general/lista-tipo-seguimiento', parametros)
        .then((response) => {
            commit('setMostrarTipoSeguimiento', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function verGraficas({state, commit}) {

    const parametros = {
        params: {
            id_empresa: state.selectedListaChequeo.id_empresa,
            id_lista_chequeo: state.selectedListaChequeo.id,
            id_tipo_seguimiento: state.selectedListaChequeo.id_tipo_lista_chequeo,
        }
    };

    commit('dashboard/load', true, {root: true});

    await $http.get('empresas/hallazgos-graficas', parametros)
        .then((response) => {
            commit('setGraficas', response.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function verGraficasEstadisticas({state, commit}, {ids, id_empresa, id_tipo_seguimiento}) {

    const parametros = {
        params: {
            id_empresa: id_empresa,
            ids: ids,
            id_tipo_seguimiento: id_tipo_seguimiento
        }
    };

    commit('dashboard/load', true, {root: true});

    await $http.get('empresas/hallazgos-graficas-estadisticas', parametros)
        .then((response) => {
            commit('setGraficas', response.data);
            commit('setTipoListaChequeo', response.data.tipo_lista_chequeo);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para descargar el reporte para plan de Acción.
 *
 * @param {*} param0
 */
export async function descargarReporteEstadisticas({state, commit}, {ids, id_empresa, id_tipo_seguimiento}) {

    const parametros = {
        id_empresa: id_empresa,
        ids: ids,
        id_tipo_seguimiento: id_tipo_seguimiento
    };

    commit('dashboard/load', true, {root: true});

    let nombre = 'Estadísticas.xlsx';

    await $http({
        url: 'empresas/reporte-estadisticas',
        method: 'POST',
        responseType: 'blob',
        params: parametros
    }).then((response) => {
        window.downloadFile(response.data, nombre)
        commit('dashboard/load', false, {root: true});
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error con la descarga del reporte',
            showConfirmButton: true,
            timer: 5000
        });
    });
}

/**
 * Metodo para ver la información de plan de acción para hallazgos.
 *
 * @param {*} param0
 * @param {*} requestParameters
 */
export async function verPlanAccion({state, commit}) {
    try {
        commit('dashboard/load', true, {root: true});
        const data = {
            id_empresa: state.selectedListaChequeo.id_empresa,
            id_lista_chequeo: state.selectedListaChequeo.id,
        };
        const response = await $http.post('empresas/hallazgos/planAccion', data);
        commit('setPlanAccion', response.data);
        return response.data;
    } catch (error) {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.errors,
            showConfirmButton: true,
            timer: 5000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}





export async function verImagenOriginal({state, commit}, id) {
    const data = {
        params: {
            id_empresa: state.selectedListaChequeo.id_empresa,
            id_lista_chequeo: state.selectedListaChequeo.id
        }
    };

    commit('dashboard/load', true, {root: true});

    await $http.get('empresas/imagen-hallazgos/mostrar-original/' + id, data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setImagen', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function getPlaneacion({commit, state}) {

    const parametros = {
        params: {
            paginado: false,
            id_empresa: state.selectedListaChequeo.id_empresa,
            id_tipo_lista_chequeo: state.selectedListaChequeo.id_tipo_lista_chequeo
        }
    };
    commit('dashboard/load', true, {root: true});

    await $http.get('empresas/planeacion-auditoria', parametros)
        .then((response) => {
            commit('setListasPlaneacionHallazgos', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit('dashboard/load', false, {root: true});
        });
}

export async function listarImagenesHallazgo({state, commit}, parametros) {
    commit('dashboard/load', true, {root: true});
    return await new Promise(async (resolve, reject) => {
        await $http.get('empresas/imagen-hallazgos', parametros)
            .then((response) => {
                commit('setListaImagenes', response.data.data);
                commit('dashboard/load', false, {root: true});
                resolve(response.data.data);
            }).catch((error) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
                reject();
            });
    });
}

export async function cambiarImagen({commit, state, dispatch}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`empresas/imagen-hallazgos/cambiar/${state.imagenChange.id}`, data, {
        headers: {'Content-Type': 'multipart/form-data'}
    })
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 1000
            });
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 3000
            });
            commit('accionError', error.message);
        });
}

export async function editarDataPlanAccion({state, commit}, data) {

    commit('dashboard/load', true, {root: true});
    await $http.post('empresas/hallazgos/planAccion/editar', data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 1000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}


/**
 * Método para descargar el reporte para plan de Acción.
 *
 * @param {*} param0
 */
export async function descargarPlanAccion({state, commit}) {

    const parametros = {
        id_empresa: state.selectedListaChequeo.id_empresa,
        id_lista_chequeo: state.selectedListaChequeo.id,
        id_tipo_seguimiento: state.selectedListaChequeo.id_tipo_lista_chequeo,
    };

    commit('dashboard/load', true, {root: true});

    let nombre = 'Plan de Acción.xlsx';
    await $http({
        url: 'empresas/plan_accion',
        method: 'POST',
        responseType: 'blob',
        params: parametros
    }).then((response) => {
        window.downloadFile(response.data, nombre)
        commit('dashboard/load', false, {root: true});
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error con la descarga del plan de acción',
            showConfirmButton: true,
            timer: 5000
        });
    });
}

export async function getRegistro({state, commit}, documento) {

    const parametros = {
        id_empresa: state.selectedListaChequeo.id_empresa,
        id_lista_chequeo: state.selectedListaChequeo.id,
        id_tipo_seguimiento: state.selectedListaChequeo.id_tipo_lista_chequeo,
    };
    commit('dashboard/load', true, {root: true});
    let nombre = documento.imagen;
    await $http({
        url: 'empresas/imagen-hallazgos/mostrar/' + documento.id,
        method: 'GET',
        responseType: 'blob',
        params: parametros
    }).then((response) => {
        window.downloadFile(response.data, nombre)
        commit('dashboard/load', false, {root: true});
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.error,
            showConfirmButton: true,
            timer: 5000
        });
    });
}

export async function eliminarAdjunto({commit, state, dispatch}, adjunto) {
    commit('dashboard/load', true, {root: true});
    await $http.delete(`empresas/imagen-hallazgos/eliminar/${adjunto.id}/${adjunto.id_empresa}`)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 1000
            });
        })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: true,
                timer: 3000
            });
        });
}

export async function seleccionarImagen({commit, state, dispatch}, id) {
    commit('dashboard/load', true, {root: true});
    await $http.put(`empresas/imagen-hallazgos/editar/${id}`, state.imagenSelecc)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 1000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 3000
            });
        });
}

/**
 * Obtener empresas desde el back
 */
export async function obtenerUbicaciones({dispatch, commit, state}, id_empresa) {
    await dispatch('obtenerUbicacionesRequest', id_empresa).then((data) => {
        commit('establecerUbicaciones', data);
    }).catch((e) => console.error(e));
}

/**
 * Obtener empresas desde el back
 */
export async function obtenerUbicacionesFiltro({dispatch, commit, state}, id_empresa) {
    await dispatch('obtenerUbicacionesRequest', id_empresa).then((data) => {
        commit('establecerUbicacionesFiltro', data);
    }).catch((e) => console.error(e));
}

/**
 * Obtener empresas desde el back
 */
export async function obtenerUbicacionesRequest({dispatch, commit, state}, id_empresa) {
    if (id_empresa) {
        return await new Promise(async (resolve, reject) => {
            commit('dashboard/load', true, {root: true});
            await $http.get(`company/location/tree/${id_empresa}`)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.data);
                }).catch(() => {
                    commit('dashboard/load', false, {root: true});
                    reject();
                });
        });
    }
}



/**
 * Listado de hallazgos
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function getFindings({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`management-Of-finding`, { params: payload});
        return response.data;
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}



/**
 * Listado de usuarios y sus hallazgos.
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function getResponsibles({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`inspections-responsibles`, { params: payload});
        return response.data.data;
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}



/**
 * Actualizar responsables de hallazgos con trabajadores
 * @param payload
 * @autor Paul Valencia
 */
export async function updateCheckLists({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.put(`inspections-responsibles/edit`, payload);
        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Muy bien!',
            text: response.data.message,
            showConfirmButton: false,
            timer: 1000
        });
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}
